import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Lock, ArrowRight } from 'lucide-react';
import api from '@/lib/api';
import { ThemeToggle } from '@/components/ThemeToggle';
import { BrandLogo } from '@/components/BrandLogo';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Şifre en az 6 karakter olmalı'); return; }
    if (password !== confirm) { toast.error('Şifreler eşleşmiyor'); return; }
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Şifreniz güncellendi. Giriş yapabilirsiniz.');
      navigate('/');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'İşlem başarısız');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-6" data-testid="reset-page">
      <div className="absolute top-4 right-4"><ThemeToggle /></div>
      <div className="w-full max-w-sm fade-up">
        <div className="text-center mb-8">
          <BrandLogo className="text-ink mb-3 mx-auto block" />
          <h2 className="font-serif text-3xl text-ink">Yeni Şifre</h2>
          <p className="text-ink/60 text-sm mt-2">Hesabınız için yeni bir şifre belirleyin</p>
        </div>
        {!token ? (
          <p className="text-center text-sm text-redx" data-testid="reset-no-token">Geçersiz bağlantı. Lütfen sıfırlama e-postasındaki bağlantıyı kullanın.</p>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="reset-form">
            <Row placeholder="Yeni şifre" value={password} onChange={setPassword} testid="reset-password" />
            <Row placeholder="Yeni şifre (tekrar)" value={confirm} onChange={setConfirm} testid="reset-confirm" />
            <button type="submit" disabled={busy} data-testid="reset-submit"
              className="w-full flex items-center justify-center gap-2 bg-ink text-ground py-3.5 rounded-xl font-semibold transition-transform active:scale-95 disabled:opacity-50">
              {busy ? 'Kaydediliyor...' : 'Şifreyi Güncelle'} {!busy && <ArrowRight strokeWidth={1.5} className="w-4 h-4" />}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const Row = ({ placeholder, value, onChange, testid }) => (
  <div className="relative">
    <Lock strokeWidth={1.5} className="w-4 h-4 text-ink-faint absolute left-3.5 top-1/2 -translate-y-1/2" />
    <input data-testid={testid} type="password" placeholder={placeholder} value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-ground border border-line rounded-xl py-3 pl-10 pr-3.5 text-sm text-ink placeholder:text-ink-faint focus:outline-none focus:ring-2 focus:ring-gold/40 focus:border-gold transition-colors" />
  </div>
);
